export default {
    state: {
        loggedIn: false,
        verifiedMail: false,
        data: {},
    },

    isLoggedIn() {
        return this.state.loggedIn;
    },

    hasVerifiedMail() {
        return this.state.verifiedMail;
    },

    loggedIn() {
        this.state.loggedIn = true;
    },

    verifiedMail() {
        this.state.verifiedMail = true;
    },

    setData(data) {
        this.state.data = data;
    }
}
